import './App.css';
import './default.css';
import './dashboard.css';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { Suspense, lazy, useEffect } from 'react';

import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import Loading from './components/Loading';

import SportsServices from './pages/sports/SportsServices';
import ConcertInsurance from './pages/service-pages/ConcertInsurance';
import FestivalExhibitionInsurance from './pages/service-pages/FestivalExhibitionInsurance';
import CorporateEventInsurance from './pages/service-pages/CorporateEventInsurance';
import EntertainmentInsurance from './pages/service-pages/EntertainmentInsurance';

// Lazy load pages/components
const Home = lazy(() => import('./pages/home/Home'));
const About = lazy(() => import('./pages/about-us/About'));
const Personal = lazy(() => import('./pages/personal/Personal'));
const Professional = lazy(() => import('./pages/professional/Professional'));
const Sports = lazy(() => import('./pages/sports/Sports'));
const Vendor = lazy(() => import('./pages/vendor/Vendor'));
const Wedding = lazy(() => import('./pages/wedding/Wedding'));
const SpecialEvents = lazy(() => import('./pages/special-events/SpecialEvents'));
const Entertainment = lazy(() => import('./pages/entertainment/Entertainment'));
const Partners = lazy(() => import('./pages/partners/Partners'));
const TermsService = lazy(() => import('./pages/terms-service/TermsService'));
const PrivacyPolicy = lazy(() => import('./pages/privacy-policy/PrivacyPolicy'));
const EventForm = lazy(() => import('./components/EventForm'));
const FormLinks = lazy(() => import('./components/FormLinks'));
const SuccessPage = lazy(() => import('./pages/payment-success/SuccessPage'));
const CancelPage = lazy(() => import('./pages/payment-cancel/CancelPage'));
const ThankYou = lazy(() => import('./pages/thank-you/ThankYou'));
const PageNotFound = lazy(() => import('./pages/page-not-found/PageNotFound'));

const PersonalServices = lazy(() => import('./pages/personal/PersonalServices'));
const ProfessionalServices = lazy(() => import('./pages/professional/ProfessionalServices'));
const VendorServices = lazy(() => import('./pages/vendor/VendorServices'));

const VendorInsurance = lazy(() => import('./pages/service-pages/VendorInsurance'));
const OneDayEvent = lazy(() => import('./pages/service-pages/OneDayEvent'));
const BirthdayPartyInsurance = lazy(() => import('./pages/service-pages/BirthdayPartyInsurance'));
const GeneralLiabilityInsurance = lazy(() => import('./pages/service-pages/GeneralLiabilityInsurance'));
const WeddingInsurance = lazy(() => import('./pages/service-pages/WeddingInsurance'));
const BabyShowerInsurance = lazy(() => import('./pages/service-pages/BabyShowerInsurance'));
const PartyInsurance = lazy(() => import('./pages/service-pages/PartyInsurance'));

const SpecialEventInsurance = lazy(() => import('./pages/service-pages/SpecialEventInsurance'));
const BaseballInsuranceUSA = lazy(() => import('./pages/service-pages/BaseballInsuranceUSA'));
const BasketballInsuranceUSA = lazy(() => import('./pages/service-pages/BasketballInsuranceUSA'));
const BowlingInsuranceUSA = lazy(() => import('./pages/service-pages/BowlingInsuranceUSA'));
const KickballInsuranceUSA = lazy(() => import('./pages/service-pages/KickballInsuranceUSA'));
const HockeyInsuranceUSA = lazy(() => import('./pages/service-pages/HockeyInsuranceUSA'));

function App() {
  useEffect(() => {
    AOS.init();
  }, []);
  return (
    <>
      <BrowserRouter>
        <Header />
        <ScrollToTop />
        <Suspense fallback={<Loading />}>
          <Routes>
            <Route index element={<Home />} />
            <Route path='/about' element={<About />} />
            <Route path='/form/:label' element={<EventForm />} />
            <Route path='/form-links' element={<FormLinks />} />
            <Route path='/personal' element={<Personal />} />
            <Route path='/Professional' element={<Professional />} />
            <Route path='/sports' element={<Sports />} />
            <Route path='/vendor' element={<Vendor />} />
            <Route path='/wedding' element={<Wedding />} />
            <Route path='/special-events' element={<SpecialEvents />} />
            <Route path='/entertainment' element={<Entertainment />} />
            <Route path='/partners' element={<Partners />} />
            <Route path='/terms-service' element={<TermsService />} />
            <Route path='/privacy-policy' element={<PrivacyPolicy />} />
            <Route path="/success" element={<SuccessPage />} />
            <Route path='/thank-you' element={<ThankYou />} />
            <Route path="/cancel" element={<CancelPage />} />
            <Route path="*" element={<PageNotFound />} />

            <Route path="/personal-services" element={<PersonalServices />} />
            <Route path="/professional-services" element={<ProfessionalServices />} />
            <Route path="/vendor-services" element={<VendorServices />} />
            <Route path="/sports-services" element={<SportsServices />} />

            <Route path="/service/special-event-insurance" element={<SpecialEventInsurance />} />
            <Route path="/service/concert-insurance" element={<ConcertInsurance />} />
            <Route path="/service/festival-exhibition-insurance" element={<FestivalExhibitionInsurance />} />
            <Route path="/service/corporate-event-insurance" element={<CorporateEventInsurance />} />
            <Route path="/service/entertainment-insurance" element={<EntertainmentInsurance />} />

            <Route path="/service/one-day-event-insurance" element={<OneDayEvent />} />
            <Route path="/service/birthday-party-insurance" element={<BirthdayPartyInsurance />} />
            <Route path="/service/general-liability-insurance" element={<GeneralLiabilityInsurance />} />
            <Route path="/service/wedding-insurance" element={<WeddingInsurance />} />
            <Route path="/service/baby-shower-insurance" element={<BabyShowerInsurance />} />
            <Route path="/service/party-insurance" element={<PartyInsurance />} />
            <Route path="/service/vendor-insurance" element={<VendorInsurance />} />

            <Route path="/service/baseball-insurance-usa" element={<BaseballInsuranceUSA />} />
            <Route path="/service/basketball-insurance-usa" element={<BasketballInsuranceUSA />} />
            <Route path="/service/bowling-insurance-usa" element={<BowlingInsuranceUSA />} />
            <Route path="/service/kickball-insurance-usa" element={<KickballInsuranceUSA />} />
            <Route path="/service/hockey-insurance-usa" element={<HockeyInsuranceUSA />} />
            
          </Routes>
        </Suspense>
        <Footer />
      </BrowserRouter>
    </>
  );
}


export default App;
